
const state = {
    organizations: [],
    organizationConfig: {}
}

export default state
